<template>
  <div id="instrument-operation">
    <common-search :searchList="searchList" @onSearch="onSearch" type="nfc" :newKeyToName="keyToName"></common-search>

    <common-table
      :product_list="uri_list"
      :loading="loading"
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_generateUri"
      title="万森文创NFC链接生成表"
      type="nfc"
      height="650"
      :newCheckHeader="checkedHeaders"
      :newKeyToName="keyToName"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  name: 'instrument-operation',
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  data() {
    return {
      loading: false,
      uri_list: null,
      searchList: {
        type: '',
      },
      tableHandler: [],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      uploading: '',
      checkedHeaders: ['文件夹名称', '文件类型','文件夹创建时间'],
      keyToName: this.$commondata.KEY_TO_NAME_UPLOAD,
    }
  },
  async mounted(){
    this.getMessageByPage();
  },
  watch: {
  },
  methods: {
    async getMessageByPage(){
      this.loading = true;

      let borrowType = 'admin_now';

      let options = this.$util.formatOptions(this.searchList);

      if(this.$util.isEmpty(this.order))
        this.order = "default";

      const uri_list = await this.$request.get_admin_upload(this.currentPage,this.pageSize,options.type ? options.type : '');

      this.uri_list = uri_list.data;
      this.total = uri_list.total
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-operation{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/GenerateUri.vue